import { Align } from 'chart.js';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { FormatProperties } from 'models/response/modelOutput.interface';

import formatValue from './FormatValues';

interface Properties {
  chartType?: string;
  isLegend?: boolean;
  pageWidth?: number;
  formatProperties?: FormatProperties;
  pageName?: string;
  aspectRatio: number;
  theme?: 'legacy' | 'revamp';
}

const getChartOptionsNew = ({
  chartType = 'line',
  isLegend = false,
  pageWidth = 0,
  formatProperties,
  pageName = '',
  aspectRatio,
  theme = 'legacy',
}: Properties) => {
  const isRevamp = theme === 'revamp';
  const axisColor = isRevamp ? '#121826' : '#212121';
  const gridColor = isRevamp ? '#E8E9EB' : '#97979766';

  return {
    aspectRatio,
    responsive: true,
    maintainAspectRatio: false,
    layout: isRevamp
      ? {
          padding: {
            top: 8,
            bottom: 4,
            left: 4,
            right: 8,
          },
        }
      : undefined,
    plugins: {
      title: { display: false },
      tooltip: {
        color: '#979797',
        callbacks: {
          label(context: any) {
            const label = context.dataset.label || '';
            const value = context.formattedValue || '';

            if (formatProperties?.measure === '%') {
              return `${label}: ${value * 100}`;
            }
            return `${label}: ${value}`;
          },
        },
      },
      legend: {
        display: isLegend,
        position: 'top' as const,
        align: 'start' as Align,
        labels: {
          boxWidth: pageWidth < 576 ? 10 : 15,
          boxHeight: pageWidth < 576 ? 10 : 15,
          color: '#979797',
        },
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        stacked: chartType === 'stacked bar',
        grid: {
          color: 'transparent',
          borderColor: isRevamp ? '#D9D9D9' : '#97979766',
        },
        ticks: {
          autoSkip: true,
          maxRotation: 0,
          minRotation: 0,
          color: axisColor,
          padding: isRevamp ? 6 : 10,
          font: isRevamp ? { size: 10, family: 'regular_roboto' } : undefined,
        },
      },
      y: {
        beginAtZero: true,
        stacked: chartType === 'stacked bar',
        grid: {
          color: gridColor,
          borderColor: 'transparent',
          tickColor: 'transparent',
        },
        ticks: {
          color: axisColor,
          padding: 0,
          font: isRevamp ? { size: 12, family: 'regular_roboto' } : undefined,
          callback(value: any) {
            if (pageName === 'drivers') {
              if (formatProperties?.measure === '%') {
                return `${value * 100}%`;
              }
              return `${formatValue(value, formatProperties as FormatProperties)}`;
            }

            return value.toLocaleString();
          },
        },
      },
    },
  };
};

export default getChartOptionsNew;
